export default __webpack_public_path__ + "static/media/pic3.0145d985.svg";